module.exports = __webpack_public_path__ + "static/media/fontanelles_vertical.172bdaed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fontanelles_vertical.png
// module id = 1762
// module chunks = 0